export default __webpack_public_path__ + "static/media/fnl_newhome_mobile.cb42474b.jpg";